import { BaseEntity } from "@bndes/bndes-ux4/bndes-angular-utils";
import { TipoBloqueioEnum } from "./tipo-bloqueio-enum";

export class InadimplenciaTecnica extends BaseEntity{
    id:number;
    agenteFinanceiro:number;
    dataInicio:Date;
    dataFim:Date;
    dataInsercao:Date;
    nomeUsuarioInsercao:string;
    motivo:string;
    observacoes:string;
    tipoBloqueio: string;
	dataUltimaAtualizacao:Date;
}

export const TIPOS_BLOQUEIO = [
	{
		codigo: "C",
		label: 'Contratação'
	}
	,{
		codigo: "H",
		label: 'Honra'
	}
]

export const SITUACAO_INADIMPLENCIA = [
	{
		codigo: "A",
		label: 'Ativo'
	}
	,{
		codigo: "I",
		label: 'Inativo'
	}
]